var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAsana({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#asana_svg__clip0_3429:43089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.65 9.53c-2.402 0-4.35 1.896-4.35 4.234 0 2.34 1.948 4.236 4.35 4.236 2.403 0 4.35-1.897 4.35-4.236 0-2.338-1.947-4.234-4.35-4.234zm-11.3 0C1.948 9.53 0 11.426 0 13.765c0 2.338 1.948 4.234 4.35 4.234 2.402 0 4.35-1.896 4.35-4.234 0-2.34-1.948-4.235-4.35-4.235zm10-5.294c0 2.339-1.948 4.235-4.35 4.235-2.402 0-4.35-1.896-4.35-4.235C5.65 1.897 7.598.001 10 .001c2.402 0 4.35 1.896 4.35 4.235z",
    fill: "url(#asana_svg__paint0_radial_3429:43089)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "asana_svg__paint0_radial_3429:43089",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(13.26 0 0 11.9329 10.003 9.849)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F95D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#F95353"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "asana_svg__clip0_3429:43089"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v18H0z"
  })))));
}

export default SvgAsana;